import { CuentaContableCuentaReadingDtoProps } from "api/DTOs/CuentaContableCuentaReadingDto"
import { CuentaContableEmpresaReadingDtoProps } from "api/DTOs/CuentaContableEmpresaReadingDto"

export function dropdownCuentaContableAdapter(
  data?: Array<
    Partial<
      CuentaContableEmpresaReadingDtoProps | CuentaContableCuentaReadingDtoProps
    >
  > | null,
  isNumberOrder?: boolean
) {
  if (!data) return []
  // @ts-expect-error TS(2339): Property 'groupBy' does not exist on type 'ObjectC...
  const groupedData = Object.groupBy(
    data,
    (
      item: Partial<
        | CuentaContableEmpresaReadingDtoProps
        | CuentaContableCuentaReadingDtoProps
      >
    ) => {
      const {
        cuentaContablePadreNumero,
        cuentaContablePadreNombre,
        grupoNumero,
        grupoNombre,
      } = item
      return `${cuentaContablePadreNumero ?? grupoNumero} - ${
        cuentaContablePadreNombre ?? grupoNombre
      }`
    }
  )

  const groups = Object.entries(groupedData)
    .map(([groupLabel, groupOptions]) => ({
      groupLabel,
      groupOptions: groupOptions
        // @ts-expect-error TS(2339): Property 'sort' does not exist on type '{}'.
        ?.sort(
          (
            a: Partial<
              | CuentaContableEmpresaReadingDtoProps
              | CuentaContableCuentaReadingDtoProps
            >,
            b: Partial<
              | CuentaContableEmpresaReadingDtoProps
              | CuentaContableCuentaReadingDtoProps
            >
          ) =>
            typeof a.numero === "string" && typeof b.numero === "string"
              ? Number(a.numero) - Number(b.numero)
              : 0
        )
        ?.map(
          (
            option: Partial<
              | CuentaContableEmpresaReadingDtoProps
              | CuentaContableCuentaReadingDtoProps
            >
          ) => ({
            optionLabel: `${option.numero} - ${option.nombre}`,
            optionValue: option.id,
          })
        ),
    }))
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    .sort((grupoA: any, grupoB: any) => {
      const numeroA = isNumberOrder
        ? Number(grupoA?.numero)
        : grupoA?.groupLabel ?? ""
      const numeroB = isNumberOrder
        ? Number(grupoB?.numero)
        : grupoB?.groupLabel ?? ""
      return isNumberOrder ? numeroA - numeroB : numeroA.localeCompare(numeroB)
    })

  return groups
}

export function dropdownCuentaContableAdapterModalAsiento(
  data?: Array<Partial<CuentaContableEmpresaReadingDtoProps>> | null
) {
  return (
    data
      ?.map((item) => ({
        label: `${item.numero ?? ""} - ${item.nombre ?? ""}`,
        value: item.id ?? "",
        numero: item.numero ?? "",
      }))
      ?.sort((a, b) => a.numero.localeCompare(b.numero)) ?? []
  )
}
